<template>
	<div>
        <el-dialog
			:visible.sync="localDialogVisible"
			width="98%"
			top="15px"
			:lock-scroll="true"
			:before-close="handleClose">
			<div slot="title" class="">
				<h4>Today Summary by Date</h4>
			</div>
			<div style="margin-top:-30px;">
				<TodaySummaryByDateTable :depositDate="localDepositDate" :stationlist="stationlist"/>
			</div>
			<span slot="footer" class="dialog-footer" style="display:none;">
				<el-button @click="localDialogVisible = false">Cancel</el-button>
				<el-button type="primary" @click="localDialogVisible = false">Confirm</el-button>
			</span>
		</el-dialog>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'

import TodaySummaryByDateTable from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryByDateTable.vue'


export default
{
	extends: Finance,
	components: { 
		TodaySummaryByDateTable,
        //ReportResultTable,
        //TableTodaySummary
		//PieChart,
		//Loader,
	},

	props: {
		depositDate: {
			type: String,
			default: '',
			required: false,
		},
		dialogVisible: {
			type: Boolean,
			default: false,
			required: false,
		},
		stationlist : {
			type: Array,
			default: () => ({}),
			required: false,
		},
    },

	data(){
		return {
			localDialogVisible: this.dialogVisible,
			localDepositDate: this.depositDate,
        }
    },

    watch: {
		depositDate(newVal) {
			console.log('Deposit Date Detail Dialog: ' + newVal);
			this.localDepositDate = newVal;
		},
		dialogVisible(newVal) {
			this.localDialogVisible = newVal;
		},
		localDialogVisible(newVal) {
			this.$emit('update:dialogVisible', newVal);
		},
    }, 

    computed: {
        
    },

    mounted() {
        this.$emit('childrenRoute');
		this.localDepositDate = this.depositDate;
		//window.addEventListener('resize', this.updateDialogPosition);
    },
	beforeDestroy() {
		//window.removeEventListener('resize', this.updateDialogPosition);
	},

    methods: { 
		handleClose(done) {
			this.$confirm('Are you sure to close this dialog?')
			.then(_ => {
				done();
				//this.dialogVisible = false;
			})
			.catch(_ => {
				//this.dialogVisible = false;
			});
		},

        applyFilter() {
            this.getData()
        },

    }
        
}

</script>

<style>

</style>